import WorkItemMetadataProvider from '~/work_items/components/work_item_metadata_provider.vue';
export default {
    name: 'WorkItemsApp',
    components: {
        WorkItemMetadataProvider
    },
    props: {
        rootPageFullPath: {
            type: String,
            required: false,
            default: undefined
        },
        withTabs: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        pageKey () {
            return this.$route.params.iid || this.$route.name;
        }
    }
};
